import React from 'react';
import { useTranslation } from 'react-i18next';

const AboutUsSection: React.FC = () => {
  const { t } = useTranslation();
  const paragraphs = (t('about.paragraphs', { returnObjects: true }) as string[]) || [];

  return (
    <section id="team" style={{ background: '#fff', padding: '64px 24px' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 14 }}>
          <span className="section-tag">{t('about.subtitle', 'О нас')}</span>
        </div>
        <h2 className="h2-center" style={{ marginBottom: 34 }}>
          {t('about.title')}
        </h2>

        <div className="grid-team">
          <div style={{ font: "400 15.5px/1.7 'Golos Text', sans-serif", color: '#3c4a32' }}>
            {paragraphs.map((p, i) => (
              <p key={i} style={{ margin: '0 0 14px' }}>
                {p}
              </p>
            ))}
            <a
              href="#contacts"
              className="pill-btn"
              style={{ marginTop: 8, fontSize: 15, padding: '13px 26px' }}
            >
              {t('about.join', 'Присоединиться')}
            </a>
          </div>
          <img
            src="/uploads/fig/team-photo.png"
            alt={t('about.title') as string}
            style={{
              width: '100%',
              borderRadius: '36px 90px 36px 90px',
              objectFit: 'cover',
              boxShadow: '0 18px 44px rgba(45,80,22,.2)'
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
